import { Box } from '@mui/material';
import { SidebarButtonsProps } from './sidebar-buttons.interface';

export function SidebarButtonsComponent({ children }: SidebarButtonsProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        p: '10px',
      }}
    >
      {children}
    </Box>
  );
}
